export default "__VITE_ASSET__o6kPPjsc__"